import { isJsonArray, isJsonObject, Json } from '@se/cp.common';
import { FullIntegrationStoreData, IExternalIntegrationCall } from './tp-integrations.interface';

export const PARSABLE_PROPS: Array<keyof IExternalIntegrationCall> = [
    'url',
    'body',
    'headers',
    'findConfig',
    'cacheKey',
];
/*decidere se aggiungere anche i path con valori non primitivi quindi oggetti ed array cosi come succede con i placeholders nella preview*/
export const modelServiceJsonToIntegrationStoreData = (
    modelData: Json,
    path: string = '',
    storeData: FullIntegrationStoreData = {},
): FullIntegrationStoreData => {
    if (isJsonArray(modelData)) {
        modelData.forEach((value, idx) => {
            const _path = path ? `${path}.${idx}` : `${idx}`;
            return modelServiceJsonToIntegrationStoreData(value, _path, storeData);
        });
    } else if (modelData && isJsonObject(modelData)) {
        Object.entries(modelData).forEach(([key, value]) => {
            const _path = path ? `${path}.${key}` : `${key}`;
            return modelServiceJsonToIntegrationStoreData(value, _path, storeData);
        });
    }

    if (path) storeData[path] = modelData;

    return storeData;
};

/**
 * la funzione inserisce i dati dei dello store nel placeholder {B_0}  dove B_ e` configurabile tramite l'ultimo parametro pre
 * @param dataStore sorgente dati in forma mappa da cui prendere i valori partendo dai placeholders
 * @param placeholders
 * @param template
 * @param pre
 */
export const fillTemplateWithData = (
    dataStore: FullIntegrationStoreData,
    placeholders: string[],
    template: string,
    pre: string = 'B_',
): string => {
    const dataToStore = placeholders.map((placeholder) => dataStore[placeholder] || '');
    const filledTemplate = dataToStore.reduce((t, data, idx) => {
        const _data = typeof data === 'object' ? JSON.stringify(data) : data;
        const reg = new RegExp(`{${pre}${idx}}`, 'g');
        return `${t}`.replace(reg, `${_data}`);
    }, template);

    return filledTemplate as string;
};

/*
* solo per testing con script locale in node.
* per aggirare il blocco sui cors
* */
export const fetchPost = async <T>(url: string, body: string = '', headers: any = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}): Promise<T> => {

    try {
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'omit',
            headers,
            referrerPolicy: 'no-referrer',
            body,
        });
        return response.json();
    } catch (err: any) {
        throw new Error(err);
    }
};
